var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui large modal zw transitionstyle" }, [
    _c(
      "div",
      { staticClass: "ui five top attached zw steps" },
      _vm._l(_vm.tabs, function(tab, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "step",
            class: {
              active: _vm.currentTab === index,
              disabled: _vm.currentTab !== index && _vm.updateDisabled
            },
            attrs: { id: tab.name },
            on: {
              click: function($event) {
                return _vm.switchTab(index)
              }
            }
          },
          [
            _c("i", { staticClass: "icon", class: tab.icon }),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(tab.title))]),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [
                _vm._v(_vm._s(tab.description))
              ])
            ])
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.tabs[_vm.currentTab].name === "product" && _vm.tabExists("product")
      ? _c("div", { staticClass: "ui active basic tab segment" }, [
          _c("div", { staticClass: "content" }, [
            _c("h3", { staticClass: "ui header" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.subscription.product.name) +
                  "\n          "
              ),
              _c("div", {
                staticClass: "ui sub header",
                domProps: { innerHTML: _vm._s(_vm.subscription.product.intro) }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui divider" }),
            _vm._v(" "),
            _c("h4", { staticClass: "ui header" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "modals.newsubscriptionmodal.product.content.description"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "description",
              domProps: {
                innerHTML: _vm._s(_vm.subscription.product.description)
              }
            })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tabs[_vm.currentTab].name === "accessories" &&
    _vm.tabExists("accessories")
      ? _c("div", { staticClass: "ui active basic tab segment" }, [
          _c("div", { staticClass: "content" }, [
            _c(
              "div",
              { staticClass: "ui four stackable cards" },
              _vm._l(_vm.subscription.product.accessories, function(accessory) {
                return _c("accessory", {
                  key: accessory.id,
                  attrs: {
                    accessory: accessory,
                    "water-meter":
                      _vm.subscription.product.category.water_meter,
                    addedAccessories: _vm.selectedAccessories,
                    changeable: true,
                    deletable: _vm.subscription.status === "deletable"
                  },
                  on: {
                    selected: _vm.selectAccessory,
                    deselected: _vm.deselectAccessory
                  }
                })
              }),
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tabExists("details")
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tabs[_vm.currentTab].name === "details",
                expression: "tabs[currentTab].name === 'details'"
              }
            ],
            staticClass: "ui active basic tab segment"
          },
          [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("div", { staticClass: "ui header" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "modals.newsubscriptionmodal.details.content.header"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticStyle: { "font-size": "16px" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "modals.newsubscriptionmodal.details.content.transaction_date"
                      )
                    ) + " - "
                  ),
                  _c("b", [_vm._v(_vm._s(_vm.subscription.transaction_date))]),
                  _vm._v(".")
                ]),
                _vm._v(" "),
                _vm.subscription.start_date > _vm.currentDate &&
                _vm.subscription.transaction_date > _vm.currentDate
                  ? _c("div", [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-weight": "700"
                          }
                        },
                        [
                          _c("i", { staticClass: "red info circle icon" }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "modals.newsubscriptionmodal.details.content.activation_later"
                                )
                              ) +
                              " (" +
                              _vm._s(_vm.subscription.start_date) +
                              ")\n\t\t\t\t  "
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.$store.getters.activeMerchant.kamstrup &&
                _vm.subscription.product.category.water_meter
                  ? [
                      _vm.subscription.kamstrup_meters.length > 0
                        ? _c("div", { staticClass: "ui one cards" }, [
                            _c("div", { staticClass: "ui divider" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "header",
                                    staticStyle: { color: "#f39c12" }
                                  },
                                  [_vm._v("Kamstrup")]
                                ),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "pages.dashboard.details.kamstrup.headers.meter_data"
                                      )
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "description" },
                                  [
                                    _c("div", { staticClass: "info-piece" }, [
                                      _c("div", { staticClass: "info-label" }, [
                                        _vm._v("From")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "info-text" }, [
                                        _vm._v(_vm._s(_vm.meterReadingFrom))
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "info-piece" }, [
                                      _c("div", { staticClass: "info-label" }, [
                                        _vm._v("To")
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "info-text" }, [
                                        _vm._v(
                                          _vm._s(_vm.meterReadingTo) +
                                            "\n                    "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "info-piece" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "info-label",
                                          staticStyle: { color: "#00a9f7" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "pages.dashboard.details.kamstrup.total"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "info-text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.subscription.kamstrup_meters[0]
                                              .meter_reading_total
                                          ) + " m3"
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _vm.subscription.pricing_amount &&
                                    parseFloat(
                                      _vm.subscription.pricing_amount
                                    ) > 0
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "info-piece" },
                                            [
                                              _c("div", {
                                                staticClass: "info-label"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "info-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      parseFloat(
                                                        _vm.subscription
                                                          .pricing_amount
                                                      )
                                                    ) + " DKK"
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ])
                            ])
                          ])
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "ui divider" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ui form",
                    attrs: { "data-vv-scope": _vm.formScope }
                  },
                  [
                    _vm._l(
                      _vm.chunkProperty(_vm.subscription.product.fields, 2),
                      function(fields, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "two fields" },
                          _vm._l(fields, function(field) {
                            return field
                              ? _c("field", {
                                  key: field.id,
                                  attrs: {
                                    field: field,
                                    allowEdit: field.editable,
                                    scope: _vm.formScope,
                                    transparent: false,
                                    value: _vm.fieldValues
                                  },
                                  on: { input: _vm.changeFieldValue }
                                })
                              : _vm._e()
                          }),
                          1
                        )
                      }
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "field",
                        class: {
                          error: _vm.errors.has(_vm.formScope + ".terms")
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ui checkbox",
                            attrs: { id: "termsbox" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              attrs: {
                                name: "terms",
                                "data-vv-as": _vm.$t(
                                  "modals.newsubscriptionmodal.details.terms"
                                ),
                                type: "checkbox",
                                "data-vv-scope": _vm.formScope
                              },
                              domProps: { checked: _vm.acceptingTerms },
                              on: {
                                change: function($event) {
                                  return _vm.changeTermsValue()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "modals.newsubscriptionmodal.details.agree_to"
                                  )
                                ) + " "
                              ),
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      _vm.showTermsModal = true
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "modals.newsubscriptionmodal.details.terms"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _vm.errors.has(_vm.formScope + ".terms")
                              ? _c("span", { staticStyle: { color: "red" } }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(_vm.formScope + ".terms")
                                    )
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]
                    )
                  ],
                  2
                )
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "semantic-modal",
              {
                attrs: {
                  settings: {
                    content_classes: { content: true },
                    closeable: false,
                    closeable_button: false
                  }
                },
                model: {
                  value: _vm.showTermsModal,
                  callback: function($$v) {
                    _vm.showTermsModal = $$v
                  },
                  expression: "showTermsModal"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ui header",
                    attrs: { slot: "header" },
                    slot: "header"
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("modals.paymentterms.header")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("payment-terms"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "actions",
                    attrs: { slot: "actions" },
                    slot: "actions"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "ui red button",
                        on: {
                          click: function($event) {
                            return _vm.denyTerms()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("globals.buttons.no")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "ui ok green button",
                        on: {
                          click: function($event) {
                            return _vm.acceptTerms()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("globals.buttons.accept")))]
                    )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.tabs[_vm.currentTab].name === "payment" && _vm.tabExists("payment")
      ? _c("div", { staticClass: "ui active basic tab segment" }, [
          _c("div", { staticClass: "content" }, [
            _c("h4", { staticClass: "ui header" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("modals.newsubscriptionmodal.payment.content.header")
                )
              )
            ]),
            _vm._v(" "),
            _vm.subscription.charge
              ? _c(
                  "span",
                  {
                    staticStyle: { "font-size": "16px", "font-weight": "700" }
                  },
                  [
                    _c("i", { staticClass: "blue info circle icon" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "modals.newsubscriptionmodal.payment.content.instant_payment"
                          )
                        ) +
                        "\n\t\t\t\t"
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ui divider" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ui zw three flex-center stackable cards" },
              _vm._l(_vm.subscription.pricing_plans, function(pricing) {
                return _c("payment-plan", {
                  key: pricing.id,
                  attrs: {
                    pricing: pricing,
                    active: _vm.selectedPaymentplan === pricing.option_id,
                    subscription: _vm.subscription
                  },
                  on: {
                    selectpayplan: _vm.selectPaymentplan,
                    deselectpayplan: _vm.deselectPaymentplan
                  }
                })
              }),
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.tabs[_vm.currentTab].name === "payment_method" &&
    _vm.tabExists("payment_method") &&
    !this.$store.getters.activeMerchant.free_subscription
      ? _c("div", { staticClass: "ui active basic tab segment" }, [
          _c("div", { staticClass: "content" }, [
            _c("h4", { staticClass: "ui header" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "modals.newsubscriptionmodal.payment_method.description"
                  )
                )
              )
            ]),
            _vm._v(" "),
            _vm.isDefaultPaymentMethod && _vm.filteredPaymentMethods.length > 0
              ? _c("p", { staticClass: "text-info text-danger" }, [
                  _vm._v(
                    "\n          * " +
                      _vm._s(
                        _vm.$t(
                          "modals.newsubscriptionmodal.payment_method.default_payment_method"
                        )
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ui divider" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ui zw two flex-center stackable cards" },
              [
                _vm.filteredPaymentMethods.length > 0
                  ? _vm._l(_vm.filteredPaymentMethods, function(paymentMethod) {
                      return _c("payment-method", {
                        key: paymentMethod.id,
                        attrs: {
                          id: paymentMethod.id,
                          name: paymentMethod.name,
                          slug: paymentMethod.slug,
                          active:
                            _vm.selectedPaymentMethod === paymentMethod.slug,
                          editable: !_vm.isDefaultPaymentMethod,
                          "payment-plan": _vm.selectedPaymentType
                        },
                        on: {
                          select: _vm.selectPaymentMethod,
                          deselect: _vm.deselectPaymentMethod
                        }
                      })
                    })
                  : [
                      _c(
                        "b",
                        {
                          staticClass: "text-center",
                          staticStyle: { "font-size": "20px", margin: "20px 0" }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "globals.validation.warning.not_all_steps_completed",
                                { 0: _vm.$t("globals.container.subscription") }
                              )
                            )
                          )
                        ]
                      )
                    ]
              ],
              2
            ),
            _vm._v(" "),
            _vm.selectedPaymentplan &&
            ((!_vm.subscription.product.category.water_meter &&
              _vm.filteredPaymentMethods.length === 1 &&
              _vm.selectedPaymentMethod === null) ||
              _vm.selectedPaymentMethod === "nets")
              ? _c("div", { staticClass: "ui divider notice" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("modals.nets_notice")) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.selectedPaymentplan && _vm.selectedPaymentMethod === "vipps"
              ? _c(
                  "div",
                  { staticClass: "ui divider notice" },
                  [
                    _vm.vippsPaymentAllowed
                      ? [
                          _vm.selectedPaymentType === "instant"
                            ? [
                                _vm.subscription.transaction_date >
                                _vm.currentDate
                                  ? [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "modals.vipps_notice_later",
                                              {
                                                transaction_date:
                                                  _vm.subscription
                                                    .transaction_date
                                              }
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("modals.vipps_notice")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                              ]
                            : [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("modals.vipps_notice_recurring")
                                    ) +
                                    "\n            "
                                )
                              ]
                        ]
                      : [
                          _vm._v(
                            "\n            Unfortunately, Vipps payment method not allowed for this Subscription. Please contact the Merchant.\n          "
                          )
                        ]
                  ],
                  2
                )
              : _vm._e()
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "actions", staticStyle: { "margin-bottom": "1rem" } },
      [
        _c(
          "div",
          {
            staticClass: "ui red button",
            on: {
              click: function($event) {
                return _vm.cancelModal()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$t("globals.buttons.cancel")))]
        ),
        _vm._v(" "),
        _vm.showPrevious
          ? _c(
              "div",
              {
                staticClass: "ui primary prev button",
                on: {
                  click: function($event) {
                    return _vm.prevTab()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.previous")) + "\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showNext
          ? _c(
              "div",
              {
                staticClass: "ui primary zw next button",
                on: {
                  click: function($event) {
                    return _vm.nextTab()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("globals.buttons.next")))]
            )
          : !_vm.showNext
          ? [
              _vm.subscription.product.category.merchant.free_subscription
                ? _c(
                    "div",
                    {
                      staticClass: "ui button green",
                      class: [
                        { "loading disabled": _vm.buttonLoader },
                        { disabled: _vm.disableActivateButton }
                      ],
                      attrs: { id: "subscribe" },
                      on: {
                        click: function($event) {
                          return _vm.validateModal()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.activate")))
                      ])
                    ]
                  )
                : _vm.subscription.start_date > _vm.currentDate &&
                  _vm.subscription.transaction_date > _vm.currentDate
                ? _c(
                    "div",
                    {
                      staticClass: "ui button green",
                      class: [
                        { "loading disabled": _vm.buttonLoader },
                        { disabled: _vm.disableActivateButton }
                      ],
                      attrs: { id: "subscribe" },
                      on: {
                        click: function($event) {
                          return _vm.validateModal()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.finish")))
                      ])
                    ]
                  )
                : _vm.selectedPaymentMethod === "vipps"
                ? _c("vipps-mobilepay-button", {
                    class: { disabled: _vm.disableActivateButton },
                    attrs: {
                      disabled: _vm.disableActivateButton,
                      type: "button",
                      brand: "vipps",
                      language: _vm.getLanguage,
                      variant: "primary",
                      rounded: "false",
                      verb: "pay",
                      stretched: _vm.isMobile,
                      branded: "true",
                      loading: _vm.buttonLoader
                    },
                    on: {
                      click: function($event) {
                        return _vm.validateModal()
                      }
                    }
                  })
                : _c(
                    "div",
                    {
                      staticClass: "ui button green",
                      class: [
                        { "loading disabled": _vm.buttonLoader },
                        { disabled: _vm.disableActivateButton }
                      ],
                      attrs: { id: "subscribe" },
                      on: {
                        click: function($event) {
                          return _vm.validateModal()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("globals.buttons.finish")))
                      ])
                    ]
                  )
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4962b27c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4962b27c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/subscription/NewSubscriptionModal.vue
// module id = kLa5
// module chunks = 1